import PropTypes from "prop-types";
import React from "react";

/**
 * -Zoom-
 * Zoom component
 **/
class Zoom extends React.Component {
	zoom = (e, direction) => {
		e.preventDefault();

		const { map } = this.props;
		const currentZoom = map.getZoom();
		const newZoom = direction === "in" ? currentZoom + 1 : currentZoom - 1;

		map.setZoom(newZoom);
	};

	render() {
		return (
			<div className="zoom-controls">
				<button className="zoom-in" onClick={ (e) => this.zoom(e, "in") }>
					<span className="assistive-text">Zoom in</span>

					<svg className="icon" aria-hidden="true">
						<use xlinkHref="#icon_plus"></use>
					</svg>
				</button>
				<button className="zoom-out" onClick={ (e) => this.zoom(e, "out") }>
					<span className="assistive-text">Zoom out</span>
					<svg className="icon" aria-hidden="true">
						<use xlinkHref="#icon_minus"></use>
					</svg>
				</button>
			</div>
		);
	}
}

export default Zoom;

Zoom.propTypes = {
	map: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/googlemaps/Zoom.js